import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import LineFloatingButton from '../../components/feature/LineFloatingButton';
import ReasonHeroSection from './components/ReasonHeroSection';
import ReasonDetailSection from './components/ReasonDetailSection';
import ReasonCTASection from './components/ReasonCTASection';
import ReasonClosingSection from './components/ReasonClosingSection';
import SeoHead from '../../components/feature/SeoHead';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://example.com';

const reasonJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  url: `${SITE_URL}/reason`,
  name: '東京シニア婚活に選ばれる理由 | 縁結び 和はは',
  description: '東京のシニア婚活相談所「縁結び和はは」が選ばれる理由。婚活東京シニア専門で50代・60代・70代の婚活を経験豊富なカウンセラーが丁寧にサポート。高い成婚率と信頼の実績。',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: SITE_URL },
      { '@type': 'ListItem', position: 2, name: '選ばれる理由', item: `${SITE_URL}/reason` },
    ],
  },
};

export default function ReasonPage() {
  return (
    <>
      <SeoHead
        title="東京シニア婚活に選ばれる理由 | 縁結び 和はは"
        description="東京のシニア婚活相談所「縁結び和はは」が選ばれる理由。婚活東京シニア専門で50代・60代・70代の婚活を経験豊富なカウンセラーが丁寧にサポート。東京シニア婚活の高い成婚率と充実したサポート体制。"
        keywords="東京 シニア 婚活, 婚活相談所 選び方 東京, シニア婚活高成婚率, 婚活カウンセラー東京, 50代婚活おすすめ東京"
        path="/reason"
        jsonLd={reasonJsonLd}
      />
      <Navbar />
      <main>
        <ReasonHeroSection />
        <ReasonDetailSection />
        <ReasonClosingSection />
        <ReasonCTASection />
      </main>
      <Footer />
      <LineFloatingButton />
    </>
  );
}
